import { Vec2Like } from './vec-like';
import { Vec2 } from './vec2';
//These functions assume that +y is north and +x is east
//its also assumed input vectors are normalized

const tmpV2A=new Vec2;
const tmpV2B=new Vec2;

export function from(x:number,y:number):number;
export function from(v:Vec2Like|number[]):number;
export function from(a:Vec2Like|number[], b:Vec2Like|number[]):number;
export function from(xOrVectorOrA:Vec2Like|number[]|number, yOrB?:Vec2Like|number[]|number):number|undefined{
	let x=0,y=0;
	if(Array.isArray(xOrVectorOrA))
		xOrVectorOrA=tmpV2A.fromArray(xOrVectorOrA);
	if(Array.isArray(yOrB))
		yOrB=tmpV2B.fromArray(yOrB);
	if(typeof(xOrVectorOrA)==='number' && typeof(yOrB)==='number'){
		x=xOrVectorOrA;
		y=yOrB;
	}else if(typeof(xOrVectorOrA)==='object' && typeof(yOrB)==='object'){
		const a=xOrVectorOrA;
		const b=yOrB;
		x=b.x-a.x;
		y=b.y-a.y;
	}else if(typeof(xOrVectorOrA)==='object'){
		x=xOrVectorOrA.x;
		y=xOrVectorOrA.y;
	}else
		throw 'bad types';

	if(x===0 && y===0){
		return undefined;
	}

	const result=Math.atan2(x,y);
	return (result + Math.PI*2) % (Math.PI*2);	// 0 to 2PI
	// return Math.atan2(x,y);
}
